export default __webpack_public_path__ + "static/media/Bot-Login-3.3ff47760.jpg";